import React, { createContext } from 'react';

import amenities from '../../../content/amenities';
import { contentGetter } from '../../../content/i18n';
import { contentGetterLinks } from '../../../content/links';
import svg from '../../../content/svg';
import contentTheme from '../../../content/contentTheme';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { compose } from 'ramda';
import { connect } from 'react-redux';
import { contextualizeAppConfig } from "@synergycms_core/store/app/utils";
import { Map } from 'immutable'
import { equals } from 'ramda';

// noinspection JSUnusedLocalSymbols
const ContentContext = createContext({});

export const withContent = contents => Child => {
  return class extends React.Component {
    static displayName = Child.displayName;
    render() {
      return (
        <ContentContext.Consumer>
          {content => <Child {...this.props} content={{ ...content.contentGetter(contents), theme: content.theme }} />}
        </ContentContext.Consumer>
      );
    }
  };
};

class ContentProvider extends React.Component {
  constructor(props) {
    super(props);
    const { theme = 'eurostarshotels', i18n, lang, links } = (props.config || {});
    this.theme = theme;

    this.assyncGetter();
    this.state = {
      amenities: amenities.getter,
      i18n: contentGetter(i18n, lang),
      links: contentGetterLinks(links, lang),
      svg: svg.getter,
      contentTheme: contentTheme.getter(theme)
    };


  }

  setContent = (mapContents) => {
    this.setState((state)=> {
      return  {...state, ...mapContents};
    });
  };


  assyncGetter = () => {
    import('@synergycms_core/content/countries').then((countryFlags) => {
      this.setContent({"countryFlags": countryFlags.default.getter});
    })
    .catch(err => {
      // Handle failure
    });
  }

   componentDidUpdate(prevProps, prevState) {
    let { theme , i18n, lang, links } = (this.props.config || {});

      if(i18n && prevProps.config.i18n !== i18n){
        var mapContents = {
          i18n: contentGetter(i18n, lang),
        };

        this.setContent(mapContents);
      }

      let prevLinks = Map.isMap(prevProps.config.links) ? prevProps.config.links.toJS() : prevProps.config.links;
      links =  Map.isMap(links) ? links.toJS() : links;
      if(!equals(links, prevLinks)){
        var mapContents = {
          links: contentGetterLinks(links, lang),
        };

        this.setContent(mapContents);
      }

      if(theme && prevProps.config.theme !== theme){
        var mapContents = {
          contentTheme: contentTheme.getter(theme)
        };
        this.setContent(mapContents);
      }

      if(lang && prevProps.config.lang !== lang){
        var mapContents = {
          i18n: contentGetter(i18n, lang),
          links: contentGetterLinks(links, lang),
        };
        this.setContent(mapContents)
      }

  }

  contentGetter = () => {
    /**
     * Return dynamic methods to get requested content
     *
     * @param {string|string[]} contents
     * @returns {{}}
     */
    return contents => {
      const requiredContents = Array.isArray(contents) ? contents : [contents];
      return requiredContents.reduce((methods, content) => {
        if (this.state[content]) {
          Object.assign(methods, this.state[content]);
        }

        return methods;
      }, {});
    };
  };

  render() {
    const { children } = this.props;
    return (
      <ContentContext.Provider
        value={{
          ...this.props.config,
          contentGetter: this.contentGetter()
        }}>
        {children}
      </ContentContext.Provider>
    );
  }
}


const mapStateToProps = (store, ownProps) => {
  const lang = store.getIn(['customer', 'lang_info', 'code']) || ownProps.value.lang;

  const hotelId = store.getIn(['customer', 'current_hotel']);
  const engineConfig = contextualizeAppConfig(store, hotelId, "engine_config");
  const i18n = engineConfig.get('i18n', ownProps.value.i18n)
  let links = engineConfig.get('links', ownProps.value.links)


  if(engineConfig.get('extra',null)){
    const extra = engineConfig.get('extra',null);
    
    let extraInfo = Map();
    if(!Map.isMap(extra)){
      const {engine_left, ...other} = extra;
      extraInfo = Map({...engine_left, ...other});
    }else{
      const extraJS = extra.toJS();
      const { engine_left, ...other } = extraJS;
      extraInfo = Map({ ...engine_left, ...other });
    }
    if(!Map.isMap(links) ){
      links = Map(links);
    }

    links = links.merge(extraInfo)
    
  }

  const theme = engineConfig.get('theme', ownProps.value.theme)

  return {
    lang,
    i18n:i18n?.toJS ? i18n.toJS() : i18n,
    links: links?.toJS ? links.toJS() : links,
    theme,
  }
}
export default compose(
  connect(
    mapStateToProps,
),
  PropertyManager([
    'lang',
    'i18n',
    'links',
    'theme'
  ]),

)(ContentProvider);